import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../fragments/button';
import {FormInline} from '../../../fragments/forms';

export default class SubmitPanel extends React.Component {

  static propTypes = {
    onUpdateMutations: PropTypes.func.isRequired,
  };

  render() {
    const {onUpdateMutations} = this.props;


    return (
      <FormInline dom="div">
        <Button
         btnStyle="primary"
         pullRight
         type="submit"
         onClick={onUpdateMutations}>
          Submit mutation list
        </Button>
      </FormInline>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/isolate/gtable_mut/submit-panel.js